var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "unified-navigation-ui": "static-1.26559",
      "ably-hubspot-js": "static-2.3319",
      "breadcrumbs-ui": "static-1.1745",
      "client-types": "static-1.372",
      "enviro": "static-4.300",
      "head-dlb": "static-1.3911",
      "hs-lodash": "static-4.45",
      "hs-promise-utils": "static-1.4269",
      "hs-test-utils": "static-1.6738",
      "hub-http": "static-1.4807",
      "hubspot-url-utils": "static-1.3109",
      "HubStyleTokens": "static-2.10237",
      "I18n": "static-7.1383",
      "jasmine-runner": "static-1.5150",
      "nav-client-types": "static-1.1133",
      "nav-meta": "static-1.25352",
      "navigation-components": "static-1.13715",
      "navigation-components-tests": "static-1.10325",
      "navigation-messaging": "static-1.3042",
      "quartz": "static-1.5498",
      "react": "static-7.151",
      "react-dnd": "static-2.33",
      "react-dnd-html5-backend": "static-2.10",
      "react-redux": "static-7.16",
      "redux": "static-4.16",
      "rpc-client-utils": "static-1.3457",
      "trials-service-types": "static-1.2832",
      "target-element-observer": "static-1.933",
      "webpack-env": "static-1.54",
      "wootric-nps": "static-1.5684",
      "ably": "static-2.2",
      "calling-internal-common": "static-1.29966",
      "classnames": "static-2.10",
      "crosstab": "static-1.3349",
      "ExtensionInstallHelpers": "static-1.529",
      "foundations-components": "static-1.5932",
      "foundations-theming": "static-1.3059",
      "foundations-theming-base": "static-1.2044",
      "foundations-theming-specialty": "static-1.776",
      "frontend-preferences-client": "static-1.6613",
      "global-search-externals": "static-1.10902",
      "idb-keyval": "static-1.20",
      "magpie-lib": "static-1.4414",
      "magpie-types": "static-1.3874",
      "metrics-js": "static-1.8511",
      "nav-onboarding-tours": "static-1.2213",
      "notification-sounds": "static-1.3176",
      "prefetcher": "static-1.4521",
      "react-dom": "static-7.85",
      "react-utils": "static-2.4270",
      "redux-thunk": "static-2.43",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.6920",
      "simple-logging-lib": "static-1.1777",
      "styled-components": "static-2.64",
      "superstore": "static-1.3513",
      "trial-components-library": "static-1.10805",
      "ts-schema": "static-1.3080",
      "ui-images": "static-2.812",
      "usage-tracker-core": "static-1.6055",
      "hs-promise-rejection-tracking": "static-1.4190",
      "PortalIdParser": "static-2.278",
      "raven": "static-3.4646",
      "raven-hubspot": "static-1.4953",
      "bend-plugin-trellis-migration": "static-1.2395",
      "moment": "static-3.26",
      "quartz-core": "static-1.4717",
      "HeadJS": "static-2.570",
      "framer-motion": "static-1.40",
      "hs-test-utils-bend-plugin": "static-1.1849",
      "msw": "static-1.39",
      "testing-library": "static-1.120",
      "i18n-data": "static-1.196",
      "moment-timezone": "static-5.51",
      "jasmine": "static-4.3082",
      "quartz-core-utils": "static-1.2365",
      "StyleGuideUI": "static-3.456",
      "csstype": "static-1.38",
      "hoist-non-react-statics": "static-3.9",
      "quick-fetch": "static-1.2772",
      "HubStyle": "static-2.10546",
      "calling-error-reporting": "static-1.29972",
      "calling-usage-tracker": "static-1.5235",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "self-service-api": "static-1.8944",
      "SharedI18nStrings": "static-1.162",
      "UIComponents": "static-3.7185",
      "bend-plugin-foundations-components": "static-1.2200",
      "floating-ui": "static-1.28",
      "foundations-assets": "static-1.3662",
      "hs-story-utils": "static-1.8135",
      "react-aria": "static-1.38",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.73",
      "tanstack-table": "static-1.23",
      "ui-fonts": "static-1.331",
      "bend-plugin-foundations-theming": "static-1.1542",
      "hub-http-janus": "static-1.642",
      "global-search-shared": "static-1.11617",
      "usage-tracker": "static-1.6205",
      "autolinker": "static-3.11",
      "sanitize": "static-1.3125",
      "transmute": "static-2.29",
      "ai-components-ui-library": "static-1.5121",
      "atom": "static-1.3960",
      "copilot-toolkit": "static-1.6029",
      "demographics-client": "static-1.4154",
      "hubs-service-types": "static-1.203",
      "icons": "static-2.591",
      "laboratory-lib": "static-3.5997",
      "onboarding-scopes": "static-1.5297",
      "react-input-autosize": "static-2.17",
      "salesImages": "static-1.499",
      "signup-constants": "static-1.16086",
      "ui-addon-i18n": "static-1.9666",
      "ui-addon-upgrades": "static-9.15949",
      "user-context": "static-1.3917",
      "dispatcher": "static-1.112",
      "general-store": "static-6.20",
      "history": "static-4.47",
      "hub-http-shared-msw-handlers": "static-1.6985",
      "hubspotter-http": "static-1.3533",
      "hubspotter-http-shared-msw-handlers": "static-1.6983",
      "mobile-manifest-mixins": "static-1.341",
      "platform-navigation-bootstrap": "static-1.11152",
      "react-rhumb": "static-1.15326",
      "react-router-dom": "static-5.26",
      "cssUtils": "static-1.476",
      "customer-data-ui-utilities": "static-1.8470",
      "ai-addon-copilot-preview": "static-1.4333",
      "apollo-link-hub-http": "static-2.3524",
      "apollo-stack-hubspot": "static-3.43",
      "data-fetching-client": "static-1.8360",
      "graphql": "static-1.58",
      "search-service-types": "static-1.2724",
      "chatspot-client-types": "static-1.8466",
      "chatspot-core": "static-1.15233",
      "ContentUtils": "static-1.62941",
      "sassPrefix": "static-1.130",
      "foundations-components-test-utils": "static-1.3417",
      "feature-store-service-types": "static-1.3424",
      "growth-monetization-service-types": "static-1.3431",
      "upgrade-management-service-types": "static-1.3415",
      "getting-started-shared-tasks": "static-1.12087",
      "getting-started-shared-tasks-store": "static-1.11205",
      "platform-infra-nav-components": "static-1.6640",
      "react-dnd-compat": "static-1.3396",
      "react-immutable-proptypes": "static-2.8",
      "react-immutable-render-mixin": "static-1.9",
      "ai-settings-ui-library": "static-1.5825",
      "apollo-dlb": "static-3.41",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.3528",
      "content-icons-ui": "static-1.1871",
      "underscore": "static-1.8",
      "ui-addon-avatars": "static-2.8156",
      "ui-addon-react-router-dom": "static-1.8351",
      "usage-tracker-container": "static-1.6195"
    },
    "depPathPrefixes": {
      "unified-navigation-ui": "/unified-navigation-ui/static-1.26559",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.3319",
      "breadcrumbs-ui": "/breadcrumbs-ui/static-1.1745",
      "client-types": "/client-types/static-1.372",
      "enviro": "/enviro/static-4.300",
      "head-dlb": "/head-dlb/static-1.3911",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hs-promise-utils": "/hs-promise-utils/static-1.4269",
      "hs-test-utils": "/hs-test-utils/static-1.6738",
      "hub-http": "/hub-http/static-1.4807",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3109",
      "HubStyleTokens": "/HubStyleTokens/static-2.10237",
      "I18n": "/I18n/static-7.1383",
      "jasmine-runner": "/jasmine-runner/static-1.5150",
      "nav-client-types": "/nav-client-types/static-1.1133",
      "nav-meta": "/nav-meta/static-1.25352",
      "navigation-components": "/navigation-components/static-1.13715",
      "navigation-components-tests": "/navigation-components-tests/static-1.10325",
      "navigation-messaging": "/navigation-messaging/static-1.3042",
      "quartz": "/quartz/static-1.5498",
      "react": "/react/static-7.151",
      "react-dnd": "/react-dnd/static-2.33",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
      "react-redux": "/react-redux/static-7.16",
      "redux": "/redux/static-4.16",
      "rpc-client-utils": "/rpc-client-utils/static-1.3457",
      "trials-service-types": "/trials-service-types/static-1.2832",
      "target-element-observer": "/target-element-observer/static-1.933",
      "webpack-env": "/webpack-env/static-1.54",
      "wootric-nps": "/wootric-nps/static-1.5684",
      "ably": "/ably/static-2.2",
      "calling-internal-common": "/calling-internal-common/static-1.29966",
      "classnames": "/classnames/static-2.10",
      "crosstab": "/crosstab/static-1.3349",
      "ExtensionInstallHelpers": "/ExtensionInstallHelpers/static-1.529",
      "foundations-components": "/foundations-components/static-1.5932",
      "foundations-theming": "/foundations-theming/static-1.3059",
      "foundations-theming-base": "/foundations-theming-base/static-1.2044",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.776",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.6613",
      "global-search-externals": "/global-search-externals/static-1.10902",
      "idb-keyval": "/idb-keyval/static-1.20",
      "magpie-lib": "/magpie-lib/static-1.4414",
      "magpie-types": "/magpie-types/static-1.3874",
      "metrics-js": "/metrics-js/static-1.8511",
      "nav-onboarding-tours": "/nav-onboarding-tours/static-1.2213",
      "notification-sounds": "/notification-sounds/static-1.3176",
      "prefetcher": "/prefetcher/static-1.4521",
      "react-dom": "/react-dom/static-7.85",
      "react-utils": "/react-utils/static-2.4270",
      "redux-thunk": "/redux-thunk/static-2.43",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.6920",
      "simple-logging-lib": "/simple-logging-lib/static-1.1777",
      "styled-components": "/styled-components/static-2.64",
      "superstore": "/superstore/static-1.3513",
      "trial-components-library": "/trial-components-library/static-1.10805",
      "ts-schema": "/ts-schema/static-1.3080",
      "ui-images": "/ui-images/static-2.812",
      "usage-tracker-core": "/usage-tracker-core/static-1.6055",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4190",
      "PortalIdParser": "/PortalIdParser/static-2.278",
      "raven": "/raven/static-3.4646",
      "raven-hubspot": "/raven-hubspot/static-1.4953",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2395",
      "moment": "/moment/static-3.26",
      "quartz-core": "/quartz-core/static-1.4717",
      "HeadJS": "/HeadJS/static-2.570",
      "framer-motion": "/framer-motion/static-1.40",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.1849",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.120",
      "i18n-data": "/i18n-data/static-1.196",
      "moment-timezone": "/moment-timezone/static-5.51",
      "jasmine": "/jasmine/static-4.3082",
      "quartz-core-utils": "/quartz-core-utils/static-1.2365",
      "StyleGuideUI": "/StyleGuideUI/static-3.456",
      "csstype": "/csstype/static-1.38",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "HubStyle": "/HubStyle/static-2.10546",
      "calling-error-reporting": "/calling-error-reporting/static-1.29972",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.5235",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "self-service-api": "/self-service-api/static-1.8944",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.162",
      "UIComponents": "/UIComponents/static-3.7185",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2200",
      "floating-ui": "/floating-ui/static-1.28",
      "foundations-assets": "/foundations-assets/static-1.3662",
      "hs-story-utils": "/hs-story-utils/static-1.8135",
      "react-aria": "/react-aria/static-1.38",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.73",
      "tanstack-table": "/tanstack-table/static-1.23",
      "ui-fonts": "/ui-fonts/static-1.331",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1542",
      "hub-http-janus": "/hub-http-janus/static-1.642",
      "global-search-shared": "/global-search-shared/static-1.11617",
      "usage-tracker": "/usage-tracker/static-1.6205",
      "autolinker": "/autolinker/static-3.11",
      "sanitize": "/sanitize/static-1.3125",
      "transmute": "/transmute/static-2.29",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.5121",
      "atom": "/atom/static-1.3960",
      "copilot-toolkit": "/copilot-toolkit/static-1.6029",
      "demographics-client": "/demographics-client/static-1.4154",
      "hubs-service-types": "/hubs-service-types/static-1.203",
      "icons": "/icons/static-2.591",
      "laboratory-lib": "/laboratory-lib/static-3.5997",
      "onboarding-scopes": "/onboarding-scopes/static-1.5297",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "salesImages": "/salesImages/static-1.499",
      "signup-constants": "/signup-constants/static-1.16086",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.9666",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.15949",
      "user-context": "/user-context/static-1.3917",
      "dispatcher": "/dispatcher/static-1.112",
      "general-store": "/general-store/static-6.20",
      "history": "/history/static-4.47",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.6985",
      "hubspotter-http": "/hubspotter-http/static-1.3533",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.6983",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.341",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11152",
      "react-rhumb": "/react-rhumb/static-1.15326",
      "react-router-dom": "/react-router-dom/static-5.26",
      "cssUtils": "/cssUtils/static-1.476",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.8470",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.4333",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.3524",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.43",
      "data-fetching-client": "/data-fetching-client/static-1.8360",
      "graphql": "/graphql/static-1.58",
      "search-service-types": "/search-service-types/static-1.2724",
      "chatspot-client-types": "/chatspot-client-types/static-1.8466",
      "chatspot-core": "/chatspot-core/static-1.15233",
      "ContentUtils": "/ContentUtils/static-1.62941",
      "sassPrefix": "/sassPrefix/static-1.130",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.3417",
      "feature-store-service-types": "/feature-store-service-types/static-1.3424",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.3431",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.3415",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.12087",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.11205",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6640",
      "react-dnd-compat": "/react-dnd-compat/static-1.3396",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.5825",
      "apollo-dlb": "/apollo-dlb/static-3.41",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.3528",
      "content-icons-ui": "/content-icons-ui/static-1.1871",
      "underscore": "/underscore/static-1.8",
      "ui-addon-avatars": "/ui-addon-avatars/static-2.8156",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.8351",
      "usage-tracker-container": "/usage-tracker-container/static-1.6195"
    },
    "project": "unified-navigation-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};